<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 21.01H8C5.23858 21.01 3 18.7714 3 16.01V8.01001C3 5.24859 5.23858 3.01001 8 3.01001H14.9289C16.255 3.01001 17.5268 3.53679 18.4645 4.47448L19.5355 5.54554C20.4732 6.48322 21 7.75499 21 9.08108V16.01C21 18.7714 18.7614 21.01 16 21.01Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 3.01001V6.01001C15 7.66686 16.3431 9.01001 18 9.01001H21"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 9.01001H11"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 12.51L17 12.5099"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 16.01H17"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
